export default __webpack_public_path__ + "static/media/list-group.81cdc78f.svg";